import thunk from "redux-thunk";
import { createStore, applyMiddleware, compose } from "redux";
import reducer from './reducer';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {};
const middlewares = [thunk];

const persistConfig = {
    key: 'root',
    storage,
}
const pReducer = persistReducer(persistConfig, reducer);
const store = createStore(pReducer, initialState, compose(applyMiddleware(...middlewares)));
const persistor = persistStore(store);
export { persistor, store };
